<template>
  <!-- 交易明细 -->
  <div class="transaction">
       <!-- 面包屑导航-->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>财务结算</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/radingCenter' }">交易记录</el-breadcrumb-item>
      <el-breadcrumb-item>交易明细</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 内容 -->
    <el-card class="main" style="margin-top:20px">
    <el-table :data="applyNoData" style="width: 100%">
          <el-table-column label="申请编号" prop="applyNo"></el-table-column>
          
          <!-- <el-table-column label="录入人" prop="creator"></el-table-column> -->
          <!-- <el-table-column label="币种" prop="toCurrency"></el-table-column> -->
          <el-table-column label="金额">
            <template slot-scope="scope">
              {{scope.row.toMoney}} {{scope.row.toCurrency}}
            </template>
          </el-table-column>
          <el-table-column label="费用名称" prop="feeName"></el-table-column>
          <!-- <el-table-column label="费用英文名称" prop="feeNameEn"></el-table-column> -->
          <!-- <el-table-column label="订单状态" prop="status"></el-table-column> -->
          <el-table-column label="销账时间">
              <template slot-scope="scope">
            <span>{{ scope.row.settleTime | dateformat }}</span>
          </template>
          </el-table-column>
          <el-table-column label="录入时间 ">
              <template slot-scope="scope">
            <span>{{ scope.row.createTime | dateformat }}</span>
          </template>
          </el-table-column>
          <!-- <el-table-column label="结算对象" prop="settleName"></el-table-column> -->
    </el-table>
    </el-card>
  </div>
</template>
<script>
//引入api
import httpApi from "@/http/api";
export default {
  data() {
    return {
      applyNoData: []
    };
  },
  methods: {
    init() {
      let that = this;
      httpApi
        .detailList({
          params: {
            applyNo: that.$route.params.applyNo
          }
        })
        .then(res => {
          if (res.data.code == "ok") {
            that.applyNoData = res.data.data.rows;
          } else {
            that.$message.error(res.data.message);
          }
        });
    }
  },
  created() {
    this.init();
  }
};
</script>
<style lang="less" scoped>
</style>